import moment from "moment-timezone";

const monthDayFormat = (value: string | moment.Moment) => {
  return moment(value)
    .utc()
    .format("MM/DD");
};

export { monthDayFormat };
